import { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'
import { GetServerSideProps } from 'next'

import { callApiNew } from 'api/axios'
import { formatHealthToolTypeCategory } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { checkMobile } from 'api/utils/validators'
import { HealthTools } from 'components/pages/healthTools'
import {
  CategoryHealthToolApi,
  FooterInfo,
  HealthToolByCategory,
} from 'interfaces/types'
import { getFooterDataPersist } from 'utils/isomorphicCache/footerData'
import { getNavMenuContentPersist } from 'utils/isomorphicCache/navMenuContent'

export type Props = {
  healthToolsByCategory: HealthToolByCategory[]
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
}

const HealthToolsPage = ({
  healthToolsByCategory,
  footerInfo,
  dataNavMenuContent,
}: Props) => {
  return (
    <HealthTools
      healthToolsByCategory={healthToolsByCategory}
      footerInfo={footerInfo}
      dataNavMenuContent={dataNavMenuContent}
    />
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { locale, req } = ctx
  const userAgent = `${req.headers['user-agent']}`
  const isMobileSsr = checkMobile(userAgent)
  const [
    healthToolsDataByCategories,
    footerInfo,
    dataNavMenuContent,
  ] = await Promise.all([
    callApiNew(PATHS.HEALTH_TOOL.GET_HEALTH_TOOLS_BY_CATEGORY),
    getFooterDataPersist(),
    getNavMenuContentPersist(locale),
  ])

  return {
    props: {
      healthToolsByCategory:
        (
          healthToolsDataByCategories?.data || []
        )?.map((category: CategoryHealthToolApi) =>
          formatHealthToolTypeCategory(category),
        ) || [],
      isMobileSsr,
      footerInfo: footerInfo?.data || null,
      dataNavMenuContent: dataNavMenuContent || {},
    },
  }
}

export default HealthToolsPage
